import {hoistCmp, uses} from '@xh/hoist/core';
import {ItemDetailsModel, PortfolioDetailsModel} from './ItemDetailsModel';
import {form} from '@xh/hoist/cmp/form';
import {formField} from '@xh/hoist/desktop/cmp/form';
import {checkbox, select, textInput} from '@xh/hoist/desktop/cmp/input';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';
import {filler, hbox, vframe} from '@xh/hoist/cmp/layout';
import {AccountStructureItemType} from '../../../data/DataTypes';

export const itemDetails = hoistCmp.factory<ItemDetailsModel>({
    model: uses(ItemDetailsModel),
    render({model}) {
        const detailComponent = getDetailsComponent(model.itemType);
        return panel({
            item: vframe(detailComponent),
            mask: model.apiTask,
            bbar: bbar()
        });
    }
});

function getDetailsComponent(itemType: AccountStructureItemType) {
    switch (itemType) {
        case AccountStructureItemType.BROKERAGE:
            return brokerageDetails();
        case AccountStructureItemType.PORTFOLIO:
            return portfolioDetails();
        case AccountStructureItemType.CUSTOM:
            return customDetails();
    }
}

const bbar = hoistCmp.factory<ItemDetailsModel>(({model}) => {
    if (!model.detailsModel) return;

    return toolbar(
        filler(),
        button({
            text: 'Revert',
            icon: Icon.reset(),
            intent: 'warning',
            disabled: !model.isDirty,
            onClick: () => model.revert()
        }),
        button({
            text: 'Save',
            icon: Icon.check(),
            intent: 'success',
            disabled: !model.isDirty || !model.isValid,
            onClick: () => model.saveAsync()
        })
    );
});

const brokerageDetails = hoistCmp.factory<ItemDetailsModel>(({model}) => {
    return form({
        model: model.detailsModel.formModel,
        fieldDefaults: {minimal: true, commitOnChange: true},
        items: [formField({field: 'name', item: textInput()})]
    });
});

const portfolioDetails = hoistCmp.factory<ItemDetailsModel>(({model}) => {
    const detailsModel = model.detailsModel as PortfolioDetailsModel;
    return form({
        model: detailsModel.formModel,
        fieldDefaults: {minimal: true, commitOnChange: true},
        items: [
            formField({field: 'portfolioName', item: textInput()}),
            formField({field: 'portfolioId', item: textInput()}),
            hbox(
                formField({field: 'brokerage', flex: 1, item: textInput()}),
                formField({field: 'isActive', label: 'Active?', width: 50, item: checkbox()})
            ),
            formField({
                field: 'managementType',
                item: select({options: detailsModel.managementOptions, enableFilter: false})
            }),
            formField({
                field: 'holdingsType',
                item: select({options: detailsModel.holdingsOptions, enableFilter: false})
            }),
            formField({
                field: 'taxableType',
                item: select({options: detailsModel.taxableOptions, enableFilter: false})
            })
        ]
    });
});

const customDetails = hoistCmp.factory<ItemDetailsModel>(({model}) => {
    return form({
        model: model.detailsModel.formModel,
        fieldDefaults: {minimal: true, commitOnChange: true},
        items: [formField({field: 'name', item: textInput()})]
    });
});
